import axios from "axios"

/**
 * The tutor's in-app training: the training video, then the validation quiz.
 * Stored in the `tutorTraining` data reducer.
 */

function getTutorTraining() {
    return axios.get("/api/v1/tutor-training-steps")
}

// { step_answers: { [questionId]: [answer] } }
function submitTutorTrainingQuiz({ id }, data) {
    return axios.post(`/api/v1/training-steps/${id}/submit-quizz`, data)
}

export const tutorTrainingService = {
    getTutorTraining,
    submitTutorTrainingQuiz,
}
